import svcs from 'services';
import { MainMenuIcon } from './header/mainmenu/MainMenuIcon';
import { UserProfileBtn } from './userprofile/UserProfileBtn';
import { i18ntrans } from 'language/i18nkey';
import { useLoginInfo } from 'hooks/useLoginInfo';
import { loginutil } from 'util/loginutil';
import { useZstdInfo } from 'zstd/useZstdInfo';
import styled from 'styled-components';
import { fonts } from 'style/fonts';
import { SsqImages } from 'images/SsqImages';
import { useWinResize } from 'zstd/useZstdWinResize';

// HeaderIconArea 컴포넌트 분리
export interface HeaderIconAreaProps {
  // sitelang: string;
  // trans: (key: string) => string;
  //setShowSearchBoxPopup: (v: boolean) => void;
  openCountryPopup: (countrySelect: boolean) => void;
  countrySelect: boolean;
  // loginutil: any;
  // loginInfo: any;
  checkNewAlarmCount: (userId: any) => Promise<void>;
  openUserPopup: (showUserPopup: boolean) => Promise<void>;
  showUserPopup: boolean;
  isLoadingUserPopup: boolean;
  alertNewAlarm: boolean;
  // MainMenuIcon: React.ComponentType;
  // UserProfileBtn: React.ComponentType<any>;
  main: boolean;
}

export const HeaderIconArea: React.FC<HeaderIconAreaProps> = ({
  // sitelang,
  // trans,
  //setShowSearchBoxPopup,
  openCountryPopup,
  countrySelect,
  // loginutil,
  // loginInfo,
  checkNewAlarmCount,
  openUserPopup,
  showUserPopup,
  isLoadingUserPopup,
  alertNewAlarm,
  // MainMenuIcon,
  // UserProfileBtn
  main,
}) => {
  const sitelang = svcs.svcLang.lang();
  const trans = (key: string): string => {
    return i18ntrans.header(key as any);
  };
  const loginInfo = useLoginInfo();
  const { setShowSearchBoxPopup } = useZstdInfo();
  const { isTablet } = useWinResize();
  if (isTablet) return;

  return (
    <IconArea>
      <button
        className="global-select-header"
        onClick={(e) => {
          e.stopPropagation();
          setShowSearchBoxPopup(false);
          openCountryPopup(countrySelect);
        }}
      >
        <span>{trans(`I18N_FILTER_${sitelang.toUpperCase().replace('-', '_')}`)}</span>
      </button>
      <div className="my-icon-area">
        <UserProfileBtn
          onClick={async (e) => {
            e.stopPropagation();
            setShowSearchBoxPopup(false);
            if (loginutil.islogin(loginInfo)) await checkNewAlarmCount(loginInfo?.userId);
            await openUserPopup(showUserPopup);
          }}
          loginInfo={loginInfo}
          isLoadingUserPopup={isLoadingUserPopup}
          alertNewAlarm={alertNewAlarm}
          isMobile={false}
        />
      </div>
      <MainMenuIcon main={main} />
    </IconArea>
  );
};

const IconArea = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2.4rem;

  > button {
    height: 100%;
  }

  .alarm-active {
    position: relative;
  }

  .circle {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #e6003e;
    border-radius: 100%;
    position: absolute;
    right: 0;
  }

  .search-box-btn {
    width: 12rem;
    height: 3.2rem;
    background: #eef1f6;
    border-radius: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    margin-right: 1.2rem;

    > span {
      ${fonts.regular};
      font-size: 1rem;
      color: #666e7a;
    }

    > img {
      width: 2rem;
      height: 2rem;
    }
  }

  .global-select-header {
    background: url(${SsqImages.header.icon.global_select_icon()}) left center no-repeat;
    height: 3.2rem;
    flex-shrink: 0;

    > span {
      ${fonts.regular};
      font-size: 1.2rem;
      color: #2a2c2f;
      padding-left: 2.8rem;
    }
  }

  .my-icon-area {
    width: 2.4rem;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    align-items: center;

    img {
      vertical-align: middle;
    }
  }

  @media screen and (max-width: 1199px) {
    display: none;
  }
`;
